module.exports = __webpack_public_path__ + "static/media/visa.d385d7ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Booking/svg/visa.png
// module id = 1549
// module chunks = 0